import React from "react"
import Button from "../Button.js"
import { elements } from "caradvise_shared_components"
import { withTranslation } from "react-i18next"
const { BaseModalDialog } = elements

class NotificationModal extends React.Component {
  render() {
    const { isOpen, closeModal, message, t } = this.props

    return (
      <BaseModalDialog isOpen={isOpen} toggleModal={closeModal}>
        <div style={{ margin: "15px" }}>{message}</div>
        <Button
          onClick={closeModal}
          colorStyle="orange"
          text={t("gotItText")}
          style={{ paddingTop: 5, paddingBottom: 5, marginTop: 15, marginBottom: 15 }}
        />
      </BaseModalDialog>
    )
  }
}

export default withTranslation("common")(NotificationModal)
